import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { resources } from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'zh-TW',
    debug: false,
    resources: resources,
    ns: ['common', 'home', 'equipment', 'locations', 'services', 'account', 'about', 'prepaid'],
  supportedLngs: ['zh-TW', 'ja', 'en'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // 優先讀取 localStorage，其次才是瀏覽器語言
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    // 若 localStorage 沒有記錄，預設使用繁體中文
    lng: localStorage.getItem('i18nextLng') || 'zh-TW',
  });

export default i18n;
